import React, { FC } from 'react';
import './index.scss';
import classnames from 'classnames';

interface Props {
	active: boolean;
	setActive: (value: boolean) => void;
	children: React.ReactNode;
}

const Popup: FC<Props> = props => {
	const { children, active, setActive } = props;

	return (
		<>
			{active && (
				<div className={active ? 'popup_active' : 'popup'} onClick={() => setActive?.(false)}>
					<div
						className={active ? 'popup__content_active' : 'popup__content'}
						onClick={e => e.stopPropagation()}
					>
						{children}
					</div>
				</div>
			)}
		</>
	);
};

export default Popup;
